import { render, staticRenderFns } from "./documentUploadItem.pug?vue&type=template&id=95859174&lang=pug&external"
import script from "./documentUploadItem.js?vue&type=script&lang=js&external"
export * from "./documentUploadItem.js?vue&type=script&lang=js&external"
import style0 from "./documentUploadItem.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95859174')) {
      api.createRecord('95859174', component.options)
    } else {
      api.reload('95859174', component.options)
    }
    module.hot.accept("./documentUploadItem.pug?vue&type=template&id=95859174&lang=pug&external", function () {
      api.rerender('95859174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Document/views/handleDocumentContainer/components/documentUploadItem/index.vue"
export default component.exports